import React from 'react';
import * as S from '../styles';

import statusVerde from '../../../assets/images/statusBolinhaVerde.svg';
import statusVermelha from '../../../assets/images/statusBolinhaVermelha.svg';
import statusAmarela from '../../../assets/images/statusBolinhaAmarela.svg';

export function DataLabelStatus({ title, label, status, statusId }) {
  return <S.ColLabelData statusid={statusId}>
      <S.TitleData>{title}</S.TitleData>
      <S.LabelData statusLabel={status}>
        <S.LabelImage statusLabel={status}>
          <img
            alt="img"
            src={
              statusId === 1
                ? statusVerde
                : statusId === 3
                ? statusVermelha
                : statusAmarela
            }
          />
          {label}
        </S.LabelImage>
        {statusId === 3 && (
          <S.LabelImage statusLabel={status}>
            <span>Pelo número</span>
: (43) 3305-9500
          </S.LabelImage>
        )}
      </S.LabelData>
         </S.ColLabelData>;
}
